import React from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import Button from '../../button/Button';
import { useChain, useWallet } from '../../../hooks/useEventStates';
import dispatchEvent from '../../../fns/common/dispatchEvent';
import injected from '../../../fns/wallets/injected';
import walletConnect from '../../../fns/wallets/walletConnect';
import Slider from 'react-slick';

import slide1 from '../../../assets/images/poker/finalBanner.png';

const Vip = () => {
  const account = useWallet();
  const chainId = useChain();

  const sliderSettings = {
    dots: false,
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    infinite: true,
  };

  return (
    <section className="home-vip">
      <div className="px-5 py-10 md:px-10">
        {/* Side by side on desktop, stacked on mobile */}
        <div className="flex flex-col lg:flex-row items-start gap-6">
          
          {/* LEFT SIDE (40%) */}
          <div className="w-full lg:basis-[40%] lg:pr-6">
            <h1 className="mb-3 text-3xl md:text-5xl font-bold tracking-tight lt-white">
              Enjoy the Perks of Being a MetaFans NFT Holder
            </h1>
            <h2 className="mb-5 text-lg md:text-2xl font-bold tracking-tight text-grey">
              Connect with our Ultimate Sports & Poker Club. 
              The new MetaFans season starts August 28th, 2025!
              <br />
              <a
                className="mb-2 underline"
                href="https://discord.gg/metafans"
                target="_blank"
                rel="noopener noreferrer"
              >
                Join our Discord!
              </a>
            </h2>

            {/* CTA Buttons */}
            <div className="flex flex-wrap items-center justify-start gap-2 vip-ctas">
              {!(account && chainId) ? (
                <Button
                  variant="Primary"
                  className="px-3 rounded-lg w-fit border-primary sm:px-5"
                  onClick={() => {
                    const connector = window.ethereum ? injected : walletConnect;
                    connector.connect().catch((err) => toast.error(err.message));
                  }}
                >
                  Connect Wallet
                </Button>
              ) : (
                <Button
                  variant="Primary"
                  className="px-3 rounded-lg w-fit border-primary sm:px-5"
                  onClick={() => dispatchEvent('opensaleModalRequested')}
                >
                  Mint
                </Button>
              )}

              <Link
                className="px-3 rounded-lg learn w-fit border-primary sm:px-5"
                to="/nft-utilities"
              >
                <p className="text-xs font-bold text-white sm:text-sm">Learn More</p>
              </Link>
            </div>
          </div>

          {/* RIGHT SIDE (60%) */}
          <div className="w-full lg:basis-[60%] flex">
            <Slider {...sliderSettings} className="w-full">
              <div className="w-full flex">
                <img
                  className="w-full h-auto max-h-[70vh] lg:max-h-[85vh] object-contain rounded-2xl"
                  src={slide1}
                  alt="metafans banner"
                />
              </div>
            </Slider>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Vip;
